import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef, MatDialog } from "@angular/material";
import { ConfirmationModalDialogComponent } from "../../modalDialogs/confirmationModalDialog/confirmationModalDialog.component";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { OverlaySpinnerService } from '../../components/overlayspinner/overlaySpiner.service';
import { Router } from "@angular/router";
import { UserProfileService } from "../../components/userProfile/userprofile.service";
import { snackBarMessageKey, SnackBarService } from "../../services/snackBar.service";
import { SnackBarMessageType } from "../../shared/contentTypes";
import { CoreLogService } from "../../services/log.service";
import { CoreLanguageService } from "../../services/language.service";

@Component({
  selector: "app-deleteaccountdialog",
  templateUrl: "./deleteaccountdialog.component.html",
  styleUrls: ["./deleteaccountdialog.component.scss"],
  providers: [OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteAccountDialogComponent implements OnInit {

  public deleteAccountContent: string;

  constructor(
    public bottomSheetRef: MatBottomSheetRef<DeleteAccountDialogComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public modulName: string,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _router: Router,
    private _overlaySpinnerService: OverlaySpinnerService,
    private _userProfileService: UserProfileService,
    private _snackBarService: SnackBarService,
    private _coreLogService: CoreLogService,
    private _coreLanguageService: CoreLanguageService
  ) { }

  ngOnInit() {
    const me = this;
    me.deleteAccountContent = me._coreLanguageService.value("phDeleteAccountDialog_Content");
  }

  public closeDialog(): void {
    const me = this;
    me.bottomSheetRef.dismiss();
  }

  /**
   * Function includes:
   * delete (anonymize) and logout the current Account, 
   * opens confirmation Dialog and navigate to the main Page
   */
  public async deleteAccount() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    const isCustomeranonymized = await me._userProfileService.anonymizeCustomer();
    if (isCustomeranonymized) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._bottomSheetHelperService.open(ConfirmationModalDialogComponent, {
        data: {
          title: "phDeleteAccountDialog_Confirm",
          description: "phDeleteAccountDialog_Confirm_Text",
          buttonText: "phExternalLinkModal_confirm_Button_Text",
          icon: true
        }
      });
      me._router.navigate(["/"], { replaceUrl: true });
    } else {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._snackBarService.ShowMessage(snackBarMessageKey.failed, SnackBarMessageType.Warning);
    }
  }
}
